import { CategoryEnum } from 'libs/datalayer/src';
import { StepIds } from '../motors-step/motors-step-model';

export const SUB_CATEGORY_PROPERTY_NAME = 'subCategory';
export const LAST_SAVED_STEP_ID_PROPERTY_NAME = 'lastSavedStepId';

export const MOTORS_BOAT_BY_STEP_ID: ReadonlyMap<StepIds, string> = new Map<
    StepIds,
    string
>([
    [StepIds.vehicleDetails, 'vehicleDetails'],
    [StepIds.listingDetails, 'listingDetails'],
    [StepIds.descriptionAndPhotos, 'descriptionAndPhotos'],
    [StepIds.summary, 'summary']
]);

export const getMotorsNameByStepIdAndCategory = (
    s: StepIds,
    c: CategoryEnum
): string => {
    switch (c) {
        case CategoryEnum.boatsAndMarineMotorboats:
            return MOTORS_BOAT_BY_STEP_ID.get(s);
        default:
            return '';
    }
};

export const MOTORS_BOAT_TITLES_BY_STEP_ID: ReadonlyMap<StepIds, string> = new Map<
    StepIds,
    string
>([
    [StepIds.vehicleDetails, 'Vehicle Details'],
    [StepIds.listingDetails, 'Listing Details'],
    [StepIds.descriptionAndPhotos, 'Description and Photos'],
    [StepIds.summary, 'Summary']
]);

export const getMotorsTitleByStepIdAndCategory = (
    s: StepIds,
    c: CategoryEnum
): string => {
    switch (c) {
        case CategoryEnum.boatsAndMarineMotorboats:
            return MOTORS_BOAT_TITLES_BY_STEP_ID.get(s);
        default:
            return '';
    }
};
